<template>
  <div
    class="md-card-product"
    :class="{
      'md-card-plain': cardPlain
    }"
  >
    <table width="100%"  cellspacing="0" cellpadding="0">
      <tr>
        <td width="120px" valign="top" rowspan="2" v-if="imageExists">
          <div
           
          >
            <div style="position: absolute">
              <md-button class="md-just-icon md-rose md-simple md-sm" v-if="popular">
                <md-icon>favorite</md-icon>
                <md-tooltip md-direction="right">Most popular</md-tooltip>
              </md-button>
              <md-button class="md-just-icon md-default md-simple md-sm" v-if="discount">
                <img :src="discimage" />
                <md-tooltip md-direction="right">discount</md-tooltip>
              </md-button>
              <md-button class="md-just-icon md-default" v-if="!visible">
                <md-icon>visibility_off</md-icon>
                <md-tooltip md-direction="right">invisible</md-tooltip>
              </md-button>
            </div>

            <a
              @click="onClick"
              :href="link ? link : 'javascript:void(0)'"
              style="text-align: center"
              :target="link ? '_blank' : '_self'"
            >
              <img style="width: 120px; height: 120px" :src="cardImage" />
            </a>

            <div
              v-if="!noColoredShadow && !shadowNormal && !shadowOff"
              class="colored-shadow"
              :style="shadowImageBlog(cardImage)"
            />
          </div>
        </td>
        <td style="padding-left: 10px" valign="top">
          <div
            v-if="$slots.cardContent"
            
            :class="{ 'text-center': textCenter }"
          >
            <a
              :href="link ? link : 'javascript:void(0)'"
              style="text-align: center"
              :target="link ? '_blank' : '_self'"
            >
              <slot name="cardContent" />
            </a>
          </div>
        </td>
      </tr>
      <tr>
        <td valign="top">
          <md-card-actions v-if="$slots.cardAction">
      <slot name="cardAction" />
    </md-card-actions>
        </td>
      </tr>
    </table>

    
  </div>
</template>

<script>
import { discount } from "../../services/helper";
export default {
  name: "ProductCardSmall",
  data() {
    return {
      discimage: discount
    };
  },
  props: {
    type: String,
    textCenter: Boolean,
    reverseRow: Boolean,
    cardImage: String,
    shadowNormal: Boolean,
    shadowOff: Boolean,
    cardPlain: Boolean,
    noColoredShadow: Boolean,
    link: String,
    id: String,
    popular: Boolean,
    visible: Boolean,
    discount: Boolean,
    imageExists: Boolean
  },
  methods: {
    shadowImageBlog(image) {
      return {
        backgroundImage: `url(${image})`,
        opacity: 1
      };
    },
    onClick() {
      if (!this.link) this.$emit("clicked", this.id);
    }
  }
};
</script>

<style lang="scss" scoped></style>
